import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/main.scss";
import { Provider } from "react-redux";
import store from "store";
import { UrbanCenterWithZone } from "types";
import { DocumentProductLine, DocumentProductLinePrice, Documents } from "models";

export type ReplaceNewSpType = {
  expeditionId: number | null;
  serviceProviderId: number;
  siteAddressZoneId: number | null;
  documentProductLines?: {
    id?: number;
    productId?: number;
    priceFamilyId?: number | null;
    priceFamilyValue?: string;
    quantity?: number;
    total?: string | number;
    priceMargin?: string;
    isManualPrice?: boolean;
  }[];
};

export type AppProps = {
  initialData: {
    expeditionId: number | null;
    orderDetail: Documents | null;
    orderServiceProvider: Documents | null;
    selectedProductLines: {
      priceFamilyId?: number;
      productId?: number;
      destProductId?: number;
      quantity?: number;
      productNameForClient?: string;
      unitPrice?: number;
      orderDetailLine: DocumentProductLine,
      DocumentProductLinePrices?: DocumentProductLinePrice[];
      SPDocumentProductLinePrices?: DocumentProductLinePrice[];
      documentProductLineId?: number;
    }[];
    serviceProviderZoneIds: UrbanCenterWithZone[];
    qboServiceProviderId: number | null;
  };
  onSubmit: (data: ReplaceNewSpType) => void;
};

function mountReactForm(element: HTMLElement, props: AppProps) {
  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App {...props} />
      </Provider>
    </React.StrictMode>
  );
  (element as any)._reactRoot = root;
}

function unmountReactForm(element: HTMLElement) {
  if ((element as any)._reactRoot) {
    (element as any)._reactRoot.unmount();
  }
}

// Extend the Window interface to add our globals
declare global {
  interface Window {
    renderReactForm: typeof mountReactForm;
    unmountReactForm: typeof unmountReactForm;
  }
}

// Make functions globally available when embedded in AngularJS
window.renderReactForm = mountReactForm;
window.unmountReactForm = unmountReactForm;

// DEV mode: render normally to <div id="root"> when not embedded
if (process.env.NODE_ENV !== "production") {
  const devRoot = document.getElementById("root");
  if (devRoot) {
    const root = ReactDOM.createRoot(devRoot);
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App
            initialData={{
              expeditionId: null,
              orderDetail: null,
              orderServiceProvider: null,
              selectedProductLines: [],
              serviceProviderZoneIds: [],
              qboServiceProviderId: null
            }}
            onSubmit={(data) => console.log("Submitted in dev mode:", data)}
          />
        </Provider>
      </React.StrictMode>
    );
  }
}
